interface BreadcrumbItem {
  label: string;
  path?: string;
}

interface SEOHeadProps {
  title?: string;
  description?: string;
  keywords?: string;
  canonicalUrl?: string;
  ogType?: string;
  breadcrumbs?: BreadcrumbItem[];
  schema?: Record<string, unknown>;
}

export default function SEOHead({ title, description, keywords, canonicalUrl, breadcrumbs, schema }: SEOHeadProps) {
  const pageTitle = title || '韩国漫画网-免费韩漫大全-最新热门在线漫画阅读';
  const pageDescription = description || '韩国漫画网提供海量免费韩漫在线阅读，每日更新最新热门作品，涵盖校园、恋爱、奇幻、热血等全品类题材。';
  const pageKeywords = keywords || '韩国漫画网,免费韩漫,漫画大全,在线漫画,韩漫';

  return (
    <>
      {/* 动态更新 meta 通过直接修改 document head */}
      <script
        dangerouslySetInnerHTML={{
          __html: `
            document.title = ${JSON.stringify(pageTitle)};
            document.querySelector('meta[name="description"]')?.setAttribute('content', ${JSON.stringify(pageDescription)});
            document.querySelector('meta[name="keywords"]')?.setAttribute('content', ${JSON.stringify(pageKeywords)});
            ${canonicalUrl ? `document.querySelector('link[rel="canonical"]')?.setAttribute('href', ${JSON.stringify(canonicalUrl)});` : ''}
          `,
        }}
      />

      {/* 面包屑 Schema */}
      {breadcrumbs && breadcrumbs.length > 0 && (
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              '@context': 'https://schema.org',
              '@type': 'BreadcrumbList',
              itemListElement: breadcrumbs.map((item, index) => ({
                '@type': 'ListItem',
                position: index + 1,
                name: item.label,
                item: item.path || 'http://w0ap.com/',
              })),
            }),
          }}
        />
      )}

      {/* 自定义 Schema */}
      {schema && (
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify(schema),
          }}
        />
      )}
    </>
  );
}